import { ID } from '@griply/types';

import { BatchDocuments, WriteBatchFn } from '../batch-documents';
import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type DeleteTasksOptions<
  TDocRef = unknown,
  TCollectionRef = unknown,
  TDb = FirestoreInstance,
> = {
  taskIds: ID[];
  collection: (
    db: NoInfer<TDb>,
    path: string,
    ...rest: string[]
  ) => TCollectionRef;
  doc: (collectionRef: NoInfer<TCollectionRef>, id: ID) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
  writeBatch?: WriteBatchFn<NoInfer<TDocRef>, NoInfer<TDb>>;
};

export const deleteTasks = async <
  TDocRef,
  TCollectionRef,
  TDb = FirestoreInstance,
>(
  options: DeleteTasksOptions<TDocRef, TCollectionRef, TDb>,
): Promise<void> => {
  const { taskIds, collection, doc, deleteDoc, db, writeBatch } = options;

  if (!taskIds.length) {
    return;
  }

  const taskCollection = collection(db, FirestoreCollections.Tasks);

  if (taskIds.length === 1 || !writeBatch) {
    await Promise.all(
      taskIds.map((taskId) => deleteDoc(doc(taskCollection, taskId))),
    );
    return;
  }

  const batchDocuments = new BatchDocuments(db, writeBatch);
  taskIds.forEach((taskId) => {
    batchDocuments.deleteDocument(doc(taskCollection, taskId));
  });
  await batchDocuments.commit();
};
